"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLinksContainer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _button = require("@creditas-lab/button");

var _styles = require("./styles");

var _core = require("@emotion/core");

var AppLinksContainer = function AppLinksContainer(_ref) {
  var others = Object.assign({}, _ref);
  var commonButtonProps = {
    as: 'a',
    rel: 'noopener',
    target: '_blank',
    variant: 'transparent'
  };
  return (0, _core.jsx)(_styles.Root, others, (0, _core.jsx)(_styles.Title, null, "Mais praticidade? Baixe nosso app"), (0, _core.jsx)(_styles.ButtonsGrid, {
    templateColumns: _styles.buttonColumns
  }, (0, _core.jsx)(_button.Button, (0, _extends2.default)({
    href: "https://creditasapp.onelink.me/q3aj/2b00ceb0"
  }, commonButtonProps), (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_styles.AppStoreIcon, null), "App Store")), (0, _core.jsx)(_button.Button, (0, _extends2.default)({
    href: "https://creditasapp.onelink.me/q3aj/228374b2"
  }, commonButtonProps), (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_styles.GooglePlayIcon, null), "Google Play"))));
};

exports.AppLinksContainer = AppLinksContainer;
AppLinksContainer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppLinksContainer"
};